// src/ui/Card.tsx (T1): square cards on a hairline, and the flat navy panel (one per view: the Next Step card).
// Root classes: hb-card, hb-navy-panel.
import type { ComponentChildren } from "preact";
import { cx } from "./cx";

export function Card(props: { pad?: boolean; as?: "div" | "section" | "article" | "aside"; class?: string; labelledBy?: string; children?: ComponentChildren }) {
  const Tag = props.as ?? "div";
  return (
    <Tag class={cx("hb-card", "card", props.pad !== false && "card-pad", props.class)} aria-labelledby={props.labelledBy}>
      {props.children}
    </Tag>
  );
}

/** The navy block (Next Step). Flat, square, text on navy uses the .on-navy styles. */
export function NavyPanel(props: { as?: "div" | "section" | "aside"; class?: string; labelledBy?: string; children?: ComponentChildren }) {
  const Tag = props.as ?? "section";
  return (
    <Tag class={cx("hb-navy-panel", "panel-navy", "on-navy", props.class)} aria-labelledby={props.labelledBy}>
      {props.children}
    </Tag>
  );
}
